import { IEvent, IConsumer, createConsumer, createSubscriber } from '@cian/events-log';
// oxlint-disable-next-line cian-eslint-compat/no-restricted-paths

import { EAlertType } from '../../repositories/header-frontend/microfrontend-api/types';
import { TReduxActions } from '../../types/redux';
import { TThunkAction } from '../../types/redux/thunk';
import { getUserAction } from '../user/getUserAction';
import { getLkTypeAction } from '../lkType';

export { EAlertType };

export interface IRequestAuthenticationParameters {
  alert?: EAlertType;
  onSuccess?(): TThunkAction | TReduxActions;
  onCloseNoAuth?(): TThunkAction | TReduxActions;
}

const TOPIC_USER = 'user';

type TConsumerSingleton = (() => IConsumer) & { _instance?: IConsumer };

const getUserConsumer: TConsumerSingleton = (): IConsumer => {
  if (!getUserConsumer._instance) {
    getUserConsumer._instance = createConsumer({ topic: TOPIC_USER });
  }

  return getUserConsumer._instance;
};

export function requestAuthentication(parameters?: IRequestAuthenticationParameters): TThunkAction<Promise<void>> {
  return async (dispatch, _getState, context) => {
    /* istanbul ignore else */
    if (typeof window !== 'undefined') {
      const consumer = getUserConsumer();

      const userSubscriber = createSubscriber(async (event: IEvent<unknown>) => {
        if (event.type === 'authenticated') {
          await Promise.all([dispatch(getUserAction()), dispatch(getLkTypeAction())]);

          /* istanbul ignore else */
          if (parameters && parameters.onSuccess) {
            dispatch(parameters.onSuccess());
          }

          consumer.unsubscribe(userSubscriber);

          return;
        }

        if (event.type === 'authentication_modal_closed') {
          /* istanbul ignore else */
          if (parameters && parameters.onCloseNoAuth) {
            dispatch(parameters.onCloseNoAuth());
          }

          consumer.unsubscribe(userSubscriber);
        }
      });

      consumer.subscribe(userSubscriber);

      /* istanbul ignore else */
      if (context.microfrontendsAPI) {
        await context.microfrontendsAPI.header.openAuthModal({
          autoRefresh: false,
        });
      }
    }
  };
}
